/**
 * Color palette for ProseMirror rich text editor
 *
 * Organized in 5 rows × 7 columns = 35 colors
 * Columns: Grays, Reds, Oranges, Yellows, Greens, Blues, Purples
 */
export const COLOR_PALETTE = [
  // Row 1:
  "#000000", // Gray
  "#E84121", // Red
  "#F9992E", // Orange
  "#FCEF3C", // Yellow
  "#8EA604", // Green
  "#0066CC", // Blue
  "#A06FFB", // Purple
  // Row 2:
  "#FFFFFF", // Gray
  "#F9CBCB", // Red
  "#FFEBCB", // Orange
  "#FEF8CB", // Yellow
  "#F2F6D8", // Green
  "#CBE1F6", // Blue
  "#EBD5FD", // Purple
  // Row 3:
  "#BBBBBB", // Gray
  "#F06665", // Red
  "#FDC166", // Orange
  "#FCF064", // Yellow
  "#CDD87A", // Green
  "#67A3DF", // Blue
  "#C284FB", // Purple
  // Row 4:
  "#878787", // Gray
  "#A12A14", // Red
  "#B26C1E", // Orange
  "#B1B229", // Yellow
  "#5F7400", // Green
  "#0048B2", // Blue
  "#6F4DB3", // Purple
  // Row 5:
  "#444444", // Gray
  "#5C1407", // Red
  "#663D0D", // Orange
  "#666714", // Yellow
  "#3F4F00", // Green
  "#002967", // Blue
  "#402966", // Purple
];
